"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function copyToClipboard(value, callback = () => { }) {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(() => {
            callback();
        });
    }
    else {
        /* eslint-disable */
        window.alert('The Clipboard API is not available.');
        /* eslint-enable */
    }
}
exports.default = copyToClipboard;
